import { render, staticRenderFns } from "./multipleChoice3.vue?vue&type=template&id=60ea6104&scoped=true"
import script from "./multipleChoice3.vue?vue&type=script&lang=js"
export * from "./multipleChoice3.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice3.vue?vue&type=style&index=0&id=60ea6104&prod&lang=css"
import style1 from "./multipleChoice3.vue?vue&type=style&index=1&id=60ea6104&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea6104",
  null
  
)

export default component.exports